// Product page gallery. Dawn handles the variant switching and the cart, so
// this only deals with which image is showing and keeping it in step with the
// colour the shopper picked.

(function () {
  'use strict';

  function initGallery(root) {
    var stage = root.querySelector('.gf-gallery__stage');
    var slides = [].slice.call(root.querySelectorAll('.gf-gallery__slide'));
    var thumbs = root.querySelectorAll('[data-gf-thumb]');
    var dots = root.querySelectorAll('[data-gf-dot]');
    if (!slides.length) return;

    // On a phone the images sit in a scroll rail, so the one on show is
    // whichever has scrolled to the middle. Everywhere else a class decides.
    function railed() {
      return !!stage && stage.scrollWidth > stage.clientWidth + 4;
    }

    // The rail wraps, so the last photograph shows at the left edge of the
    // first one. A copy of each end sits on the opposite side and the rail
    // jumps back to the real one once the swipe has settled, which reads as a
    // loop without the scroll position ever running away.
    var looped = false;

    // A whole set is copied to each side rather than a single photograph. One
    // is not enough road: a quick flick travels several at once, runs out of
    // rail and stops short, which is what makes a loop feel like it caught on
    // something. With a full set either way there is always somewhere to go,
    // and because the step back is exactly one set the pictures either side of
    // it are the same ones, so nothing appears to move.
    function buildLoop() {
      if (looped || slides.length < 2 || !railed()) return;

      function copy(slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('data-gf-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.remove('is-active');
        return clone;
      }

      for (var i = 0; i < slides.length; i++) stage.appendChild(copy(slides[i]));
      for (var j = slides.length - 1; j >= 0; j--) stage.insertBefore(copy(slides[j]), stage.firstChild);
      looped = true;
      jumpTo(0);
    }

    function cells() {
      return [].slice.call(stage.children);
    }

    // Where a real slide sits in the rail, the copies included. The real set is
    // the middle one of the three.
    function cellFor(index) {
      return cells()[looped ? index + slides.length : index];
    }

    function centreOf(cell) {
      return cell.offsetLeft - (stage.clientWidth - cell.offsetWidth) / 2;
    }

    // Stepping from a copy to the real photograph has to be invisible, which
    // means the snapping has to be off while it happens. Left on, the browser
    // treats the new position as a fresh scroll and animates back to the one it
    // had already chosen, which is what makes a rail fight the swipe.
    function jumpTo(index) {
      var cell = cellFor(index);
      if (!cell) return;
      var left = centreOf(cell);
      if (Math.abs(stage.scrollLeft - left) < 1) return;
      var snap = stage.style.scrollSnapType;
      stage.style.scrollSnapType = 'none';
      stage.scrollLeft = left;
      window.requestAnimationFrame(function () {
        stage.style.scrollSnapType = snap || '';
      });
    }

    // The rail takes the height of whichever photograph is in view. Without
    // this a square picture sits in a box sized for a tall one, with a band of
    // empty space beneath it.
    var shownHeight = -1;

    function fitHeight(index) {
      if (!stage) return;
      if (!railed()) { stage.style.height = ''; shownHeight = -1; return; }
      var cell = cellFor(index);
      var image = cell && cell.querySelector('img');
      if (!image) return;
      var height = image.getBoundingClientRect().height;
      if (!height || Math.abs(height - shownHeight) < 1) return;
      shownHeight = height;
      stage.style.height = height + 'px';
    }

    function mark(index) {
      fitHeight(index);
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === index);
      }
      for (var j = 0; j < thumbs.length; j++) {
        thumbs[j].classList.toggle('is-active', j === index);
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === index);
      }
    }

    function show(index) {
      mark(index);
      if (railed()) {
        var cell = cellFor(index);
        if (cell) stage.scrollTo({ left: centreOf(cell), behavior: 'smooth' });
      }
    }

    // Which cell is nearest the middle, and which real slide it stands for.
    function settled() {
      var list = cells();
      var middle = stage.scrollLeft + stage.clientWidth / 2;
      var best = 0;
      var bestGap = Infinity;
      for (var i = 0; i < list.length; i++) {
        var centre = list[i].offsetLeft + list[i].offsetWidth / 2;
        var gap = Math.abs(centre - middle);
        if (gap < bestGap) { bestGap = gap; best = i; }
      }
      if (!looped) return { cell: best, index: best };
      return { cell: best, index: best % slides.length };
    }

    function currentReal() {
      return railed() ? settled().index : currentIndex(slides);
    }

    if (stage) {
      var ticking = false;
      var pending = null;

      // Only step across once the rail has genuinely stopped. Moving it while a
      // swipe is still carrying pulls the picture out from under the finger.
      function settle() {
        if (!railed()) return;
        var at = settled();
        mark(at.index);
        // Anything outside the middle set is a stand in and needs stepping back.
        if (looped && (at.cell < slides.length || at.cell >= slides.length * 2)) {
          jumpTo(at.index);
        }
      }

      stage.addEventListener('scroll', function () {
        if (!railed()) return;
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            mark(settled().index);
          });
        }

        // Newer browsers say when scrolling has finished. The timer is kept
        // either way, at a length that outlasts the momentum of a flick, so a
        // browser that misses the event cannot leave the rail on a copy.
        window.clearTimeout(pending);
        pending = window.setTimeout(settle, 320);
      });

      if ('onscrollend' in window) stage.addEventListener('scrollend', settle);
    }

    for (var k = 0; k < thumbs.length; k++) {
      (function (index) {
        thumbs[index].addEventListener('click', function () { show(index); });
      })(k);
    }

    for (var n = 0; n < dots.length; n++) {
      (function (index) {
        dots[index].addEventListener('click', function () { show(index); });
      })(n);
    }

    function refresh() {
      buildLoop();
      shownHeight = -1;
      fitHeight(currentReal());
    }

    refresh();
    window.addEventListener('load', refresh);
    window.addEventListener('resize', refresh);

    // A picture that has not arrived yet has no height to measure.
    for (var m = 0; m < slides.length; m++) {
      var pic = slides[m].querySelector('img');
      if (pic && !pic.complete) pic.addEventListener('load', refresh);
    }

    initZoom(root, slides, currentReal);

    // Picking a colour should bring its photo forward. The variant's image is
    // matched by src rather than by index, because the media order and the
    // variant order are not the same list.
    root.addEventListener('gf:media', function (event) {
      var wanted = event.detail && event.detail.src;
      if (!wanted) return;
      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        if (img && sameImage(img.getAttribute('src'), wanted)) {
          show(i);
          return;
        }
      }
    });

    root.__gfShow = show;
  }

  function currentIndex(slides) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  // Full screen view of the photograph on show. The largest candidate in the
  // srcset is used rather than the rendered src, so the enlarged copy is not
  // the phone sized one blown up.
  function initZoom(root, slides, indexOf) {
    var open = root.querySelector('[data-gf-zoom-open]');
    var panel = root.querySelector('[data-gf-zoom]');
    if (!open || !panel) return;
    var image = panel.querySelector('.gf-zoom__image');
    var close = panel.querySelector('[data-gf-zoom-close]');

    function largest(img) {
      var set = img.getAttribute('srcset');
      if (!set) return img.currentSrc || img.src;
      var best = null;
      var widest = 0;
      set.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var width = parseInt(bits[1], 10) || 0;
        if (width > widest) { widest = width; best = bits[0]; }
      });
      return best || img.src;
    }

    function hide() {
      panel.hidden = true;
      document.body.style.overflow = '';
    }

    open.addEventListener('click', function () {
      var slide = slides[indexOf()];
      var img = slide && slide.querySelector('img');
      if (!img) return;
      image.src = largest(img);
      image.alt = img.getAttribute('alt') || '';
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
    });

    if (close) close.addEventListener('click', hide);
    panel.addEventListener('click', function (event) {
      if (event.target === panel) hide();
    });
    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && !panel.hidden) hide();
    });
  }

  // Shopify serves the same file at many widths, so compare the path and
  // ignore the query string.
  function sameImage(a, b) {
    if (!a || !b) return false;
    return a.split('?')[0].replace(/^https?:/, '') === b.split('?')[0].replace(/^https?:/, '');
  }

  function watchVariants(scope) {
    var picker = scope.querySelector('variant-selects');
    var gallery = scope.querySelector('[data-gf-gallery]');
    if (!picker || !gallery) return;

    picker.addEventListener('change', function () {
      // product-info re-renders the block, so read the variant it just wrote
      // rather than holding on to a stale copy.
      window.setTimeout(function () {
        var tag = scope.querySelector('[data-selected-variant]');
        if (!tag) return;
        var variant;
        try {
          variant = JSON.parse(tag.textContent);
        } catch (err) {
          return;
        }
        if (variant && variant.featured_image && variant.featured_image.src) {
          gallery.dispatchEvent(new CustomEvent('gf:media', {
            detail: { src: variant.featured_image.src }
          }));
        }
      }, 0);
    });
  }

  function init() {
    var galleries = document.querySelectorAll('[data-gf-gallery]');
    for (var i = 0; i < galleries.length; i++) initGallery(galleries[i]);

    var infos = document.querySelectorAll('product-info');
    for (var j = 0; j < infos.length; j++) watchVariants(infos[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
